import { useQuery } from '@tanstack/react-query';
import { useMemo } from 'react';

type LastReviewDateResponse = {
  lastReviewDate?: string;
};

export const useLastReviewDate = (clientId?: string) => {
  const { data, isLoading, isError, refetch } = useQuery<LastReviewDateResponse>({
    queryKey: ['clients', clientId, 'suitability-reports', 'last-review-date'],
    enabled: !!clientId,
  });

  const lastReviewDate = useMemo(() => {
    return data?.lastReviewDate ? new Date(data.lastReviewDate) : undefined;
  }, [data?.lastReviewDate]);

  return {
    lastReviewDate,
    isLoading,
    isError,
    refetch,
  };
};
